import React, { useEffect, useState } from "react";
import { parse } from "query-string";
import { patch } from "../../../../modules/patch.js";
import ProcessingAnimation from "../../../../../../merchant/panel/scripts/shared/ProcessingAnimation/ProcessingAnimation.js";
import Container from "../container/container.js";
import "./style.css";
export default function CollectionMain(props) {
    const [loading, setLoading] = useState(true);
    const { collId, collKey, orderId, key } = parse(location.search);
    const [errorMsg, setErrorMsg] = useState();
    const [logged, setLogged] = useState(false);
    useEffect(() => {
        document.title = "Kolekcja zdjęć";
        if (!collId || !collKey)
            return;
        patch(`/api/public/users/collections/${collId}/auth`, {
            collectionKey: collKey,
            orderId: orderId,
            orderKey: key,
        }).then((res) => {
            setLoading(false);
            if (res.status !== 200)
                return setErrorMsg("Ta kolekcja nie istnieje lub została już zakończona");
            setLogged(true);
            console.log("auth went correctly!");
        });
    }, []);
    return (React.createElement("div", { className: "collection-main" },
        (!collId || !collKey) && React.createElement(React.Fragment, null, "Nieprawid\u0142owe \u017Cadanie"),
        errorMsg,
        logged && React.createElement(Container, null),
        loading && React.createElement(ProcessingAnimation, null)));
}
